import React from 'react';
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const linkClass = 'inline-flex max-w-full break-words text-slate-400 no-underline transition-all duration-300 hover:translate-x-1 hover:text-white';

  return (
    <footer className="overflow-x-hidden bg-slate-950 text-slate-300">
      <div className="mx-auto w-full max-w-[1920px] px-4 py-10 sm:px-6 sm:py-12 lg:px-8 lg:py-14 2xl:px-10 2xl:py-16">
        <div className="grid min-w-0 gap-8 sm:grid-cols-2 lg:gap-10 xl:grid-cols-[minmax(0,1.35fr)_repeat(3,minmax(0,0.8fr))] xl:gap-12">
          <div className="min-w-0">
            <Link to="/" className="inline-flex no-underline transition-transform duration-300 hover:scale-105" aria-label="Giggs home">
              <img src="/images/logo-white.png" alt="Giggs" className="h-10 w-auto object-contain sm:h-11" />
            </Link>
            <p className="mt-5 max-w-lg break-words text-sm leading-6 text-slate-400 2xl:text-base 2xl:leading-7">
              One marketplace for two simple goals: get trusted local help when you need it, or earn flexibly by offering services in your community.
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <a href="https://www.facebook.com/people/GIGGS/61587122874856/" target="_blank" rel="noreferrer" aria-label="Giggs on Facebook" className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/10 text-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:bg-green-700 hover:shadow-lg">
                <Facebook size={18} />
              </a>
              <a href="https://www.instagram.com/giggs.au/" target="_blank" rel="noreferrer" aria-label="Giggs on Instagram" className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/10 text-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:bg-green-700 hover:shadow-lg">
                <Instagram size={18} />
              </a>
              <a href="https://www.linkedin.com/company/giggs-au/" target="_blank" rel="noreferrer" aria-label="Giggs on LinkedIn" className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/10 text-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:bg-green-700 hover:shadow-lg">
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          <div className="min-w-0">
            <h3 className="m-0 text-sm font-bold uppercase tracking-[0.18em] text-white">Explore</h3>
            <ul className="mt-5 list-none space-y-3 p-0 text-sm">
              <li><Link to="/services" className={linkClass}>Services</Link></li>
              <li><Link to="/how-it-works" className={linkClass}>How it works</Link></li>
              <li><Link to="/what-is-giggs" className={linkClass}>What is Giggs?</Link></li>
              <li><Link to="/track" className={linkClass}>Track a Gig</Link></li>
            </ul>
          </div>

          <div className="min-w-0">
            <h3 className="m-0 text-sm font-bold uppercase tracking-[0.18em] text-white">Get started</h3>
            <ul className="mt-5 list-none space-y-3 p-0 text-sm">
              <li><Link to="/book" className={linkClass}>Book a service</Link></li>
              <li><Link to="/client-register" className={linkClass}>Create client account</Link></li>
              <li><Link to="/provider-register" className={linkClass}>Become a Gigger</Link></li>
              <li><Link to="/login" className={linkClass}>Log in</Link></li>
            </ul>
          </div>

          <div className="min-w-0">
            <h3 className="m-0 text-sm font-bold uppercase tracking-[0.18em] text-white">Contact</h3>
            <div className="mt-5 space-y-4 text-sm">
              <div className="flex min-w-0 items-start gap-3 text-slate-400">
                <MapPin className="mt-0.5 shrink-0 text-green-500" size={18} />
                <span className="min-w-0 break-words">Australia wide</span>
              </div>
              <a href="mailto:info@giggs.com.au" className="flex min-w-0 items-start gap-3 text-slate-400 no-underline transition-all duration-300 hover:translate-x-1 hover:text-white">
                <Mail className="mt-0.5 shrink-0 text-green-500" size={18} />
                <span className="min-w-0 break-all">info@giggs.com.au</span>
              </a>
              <a href="tel:+61285284599" className="flex min-w-0 items-start gap-3 text-slate-400 no-underline transition-all duration-300 hover:translate-x-1 hover:text-white">
                <Phone className="mt-0.5 shrink-0 text-green-500" size={18} />
                <span className="min-w-0 break-words">+61 2 8528 4599</span>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-slate-500 sm:mt-12 sm:flex-row sm:items-center sm:justify-between">
          <span>© 2026 GIGGS. All rights reserved.</span>
          <span>Find a Gig. Get a Gig done.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
